import React, { useState } from 'react';

interface ImagePreviewProps {
    image: string | null;
    onClose: () => void;
}

export function ImagePreview({ image, onClose }: ImagePreviewProps) {
    const [zoomLevel, setZoomLevel] = useState(1);
    
    if (!image) return null;

    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.25, 1.5));
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
    };

    const handleReset = () => {
        setZoomLevel(1);
    };

    return (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center" onClick={onClose}>
            <div 
                className="inline-flex items-center justify-center relative bg-black/30 p-4 rounded-lg max-h-[80vh]"
                onClick={(e) => e.stopPropagation()}
                style={{ 
                    maxWidth: '90vw',
                    minWidth: '70vw', 
                    minHeight: '70vh', 
                    position: 'absolute',
                    top: '50%',
                    left: '60%', 
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <button 
                    className="absolute top-2 right-2 w-8 h-8 bg-neutral-600 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer z-10"
                    onClick={onClose}
                    title="Close Preview"
                    aria-label="Close Image preview"
                >
                    <i className="fas fa-times text-neutral-100" />
                </button>
                
                <img 
                    src={image} 
                    alt="Preview" 
                    className="max-w-full max-h-[70vh] object-contain rounded-md transition-transform duration-200"
                    style={{ 
                        transform: `scale(${zoomLevel})`,
                        transformOrigin: 'center'
                    }}
                />
                
                {/* Zoom controls */}
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-2">
                    <button 
                        className="w-8 h-8 bg-neutral-600 hover:bg-neutral-500 rounded-full flex items-center justify-center transition-colors duration-200"
                        onClick={handleZoomOut}
                        title="Zoom Out"
                        aria-label="Zoom Out"
                    >
                        <i className="fas fa-minus text-neutral-100" />
                    </button>
                    <button 
                        className="w-8 h-8 bg-neutral-600 hover:bg-neutral-500 rounded-full flex items-center justify-center transition-colors duration-200"
                        onClick={handleReset}
                        title="Reset Zoom"
                    >
                        <span className="text-neutral-100 text-xs font-bold">{Math.round(zoomLevel * 100)}%</span>
                    </button>
                    <button 
                        className="w-8 h-8 bg-neutral-600 hover:bg-neutral-500 rounded-full flex items-center justify-center transition-colors duration-200"
                        onClick={handleZoomIn}
                        title="Zoom In"
                        aria-label="Zoom In"
                    >
                        <i className="fas fa-plus text-neutral-100" />
                    </button>
                </div>
            </div>
        </div>
    );
};

